import React from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import AuthLayout from '../../layouts/AuthLayout';

const { Title, Text } = Typography;

export default function PaymentSuccessPage() {
  return (
    <AuthLayout>
      <div style={{ textAlign: 'center', padding: '48px 24px' }}>
        <CheckCircleOutlined style={{ fontSize: 64, color: '#52c41a', marginBottom: 24 }} />
        <Title level={2} style={{ color: '#fff', marginBottom: 8 }}>
          ¡Pago completado!
        </Title>
        <Text style={{ color: 'rgba(255,255,255,0.65)', display: 'block', marginBottom: 32 }}>
          Tu membresía puede tardar unos segundos en activarse.
        </Text>
        <Button type="primary" size="large" href="https://futpremia.com/">
          Volver al portal
        </Button>
      </div>
    </AuthLayout>
  );
}
